var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15H21V24C21 25.6569 22.3431 27 24 27H38C39.6569 27 41 25.6569 41 24V15.2047C41.0353 15.2317 41.069 15.2611 41.1008 15.2929L46.7071 20.8992C46.8946 21.0867 47 21.3411 47 21.6063V46C47 46.5523 46.5523 47 46 47H43V34C43 32.3431 41.6569 31 40 31H22C20.3431 31 19 32.3431 19 34V47H16C15.4477 47 15 46.5523 15 46V16C15 15.4477 15.4477 15 16 15ZM16 13H21H23H39H40.3937H41V13.0619C41.5697 13.1794 42.0975 13.4612 42.515 13.8787L48.1213 19.485C48.6839 20.0476 49 20.8106 49 21.6063V46C49 47.6569 47.6569 49 46 49H43H41H21H19H16C14.3431 49 13 47.6569 13 46V16C13 14.3431 14.3431 13 16 13ZM23 24V15H39V24C39 24.5523 38.5523 25 38 25H24C23.4477 25 23 24.5523 23 24ZM21 47H41V34C41 33.4477 40.5523 33 40 33H22C21.4477 33 21 33.4477 21 34V47ZM35 17C34.4477 17 34 17.4477 34 18V22C34 22.5523 34.4477 23 35 23H36C36.5523 23 37 22.5523 37 22V18C37 17.4477 36.5523 17 36 17H35Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportActive);
export default __webpack_public_path__ + "static/media/export-active.941ac090dd8b6731b5f0d3d0afd8b118.svg";
export { ForwardRef as ReactComponent };